import type { Lead } from '@/shared/types';

/** Cooldown entre reenvios de cartão (24h). */
export const CARD_RESEND_COOLDOWN_MS = 24 * 60 * 60 * 1000;

export interface ResendEligibility {
  allowed: boolean;
  remainingMs: number;
}

export function canResendCard(lead: Pick<Lead, 'lastCardResendAt'>, now = Date.now()): ResendEligibility {
  if (!lead.lastCardResendAt) return { allowed: true, remainingMs: 0 };
  const last = new Date(lead.lastCardResendAt).getTime();
  if (Number.isNaN(last)) return { allowed: true, remainingMs: 0 };
  const elapsed = now - last;
  if (elapsed >= CARD_RESEND_COOLDOWN_MS) return { allowed: true, remainingMs: 0 };
  return { allowed: false, remainingMs: CARD_RESEND_COOLDOWN_MS - elapsed };
}

export function formatCooldownRemaining(ms: number): string {
  const hours = Math.ceil(ms / (60 * 60 * 1000));
  if (hours <= 1) return 'menos de 1h';
  return `${hours}h`;
}

